// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statistics-page {
  padding: 24px;
}

.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  font-size: 28px;
  color: #333;
  margin: 0 0 8px 0;
}

.page-header p {
  color: #666;
  margin: 0;
}

.loading-spinner {
  text-align: center;
  padding: 60px;
  color: #666;
  font-size: 16px;
}

.error-message {
  background: #fee;
  color: #c00;
  padding: 12px 16px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.error-message button {
  background: #c00;
  color: white;
  border: none;
  padding: 6px 16px;
  border-radius: 6px;
  cursor: pointer;
}

.stats-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 32px;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border-left: 4px solid #ddd;
  transition: transform 0.2s;
}

.stat-card:hover {
  transform: translateY(-2px);
}

.stat-card.total { border-left-color: #6c63ff; }
.stat-card.assigned { border-left-color: #0066cc; }
.stat-card.completed { border-left-color: #17a2b8; }
.stat-card.successful { border-left-color: #28a745; }
.stat-card.unsuccessful { border-left-color: #dc3545; }
.stat-card.spam { border-left-color: #7c3aed; }
.stat-card.amount { border-left-color: #ffc107; }

.stat-icon {
  font-size: 28px;
}

.stat-icon svg {
  width: 28px;
  height: 28px;
}

.stat-card.total .stat-icon { color: #6c63ff; }
.stat-card.assigned .stat-icon { color: #0066cc; }
.stat-card.completed .stat-icon { color: #17a2b8; }
.stat-card.successful .stat-icon { color: #28a745; }
.stat-card.unsuccessful .stat-icon { color: #dc3545; }
.stat-card.spam .stat-icon { color: #7c3aed; }
.stat-card.amount .stat-icon { color: #b45309; }

.stat-info {
  flex: 1 1;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #333;
}

.stat-label {
  font-size: 12px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 2px;
}

.stats-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.stats-section h3 {
  margin: 0 0 4px 0;
  font-size: 18px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 7px;
}

.stats-section h3 svg {
  width: 19px;
  height: 19px;
}

.section-subtitle {
  color: #888;
  font-size: 13px;
  margin: 0 0 16px 0;
}

.source-section {
  margin-bottom: 24px;
}

.source-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
}

.source-card {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 14px 16px;
  border: 1px solid #eee;
  transition: transform 0.15s, box-shadow 0.15s;
}

.source-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.source-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.source-name {
  font-weight: 600;
  font-size: 14px;
  color: #333;
  text-transform: capitalize;
}

.source-count {
  font-weight: 700;
  font-size: 18px;
  color: #0066cc;
}

.source-bar-bg {
  height: 6px;
  background: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 8px;
}

.source-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #0066cc, #00a8ff);
  border-radius: 3px;
  transition: width 0.5s ease;
  min-width: 2px;
}

.source-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.source-pct {
  font-weight: 600;
  color: #555;
}

.source-breakdown {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.source-success,
.source-fail,
.source-pending {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.source-success { color: #28a745; }
.source-fail { color: #dc3545; }
.source-pending { color: #6c757d; }

.source-success svg,
.source-fail svg,
.source-pending svg {
  width: 12px;
  height: 12px;
}
.source-spam {
  color: #7c3aed;
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.source-spam svg {
  width: 12px;
  height: 12px;
}

.source-amount {
  margin-top: 6px;
  font-size: 12px;
  color: #28a745;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.source-amount svg {
  width: 14px;
  height: 14px;
}

.table-wrapper {
  overflow-x: auto;
}

.stats-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.stats-table th {
  background: #f8f9fa;
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: #555;
  border-bottom: 2px solid #dee2e6;
  white-space: nowrap;
}

.stats-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.stats-table tbody tr:hover {
  background: #f8f9fa;
}

.center {
  text-align: center;
}

.employee-name {
  font-weight: 500;
}

.success-cell {
  color: #28a745;
  font-weight: 600;
}

.fail-cell {
  color: #dc3545;
  font-weight: 600;
}

.spam-cell {
  color: #7c3aed;
  font-weight: 600;
}

.amount-cell {
  text-align: right;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
}

.rate-bar-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
}

.rate-bar {
  height: 8px;
  background: linear-gradient(90deg, #28a745, #20c997);
  border-radius: 4px;
  min-width: 2px;
  transition: width 0.5s ease;
  flex: 1 1;
  max-width: 80px;
}

.rate-label {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  min-width: 35px;
}

.totals-row {
  background: #f0f7ff !important;
}

.totals-row td {
  border-top: 2px solid #dee2e6;
  border-bottom: none;
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: #888;
}

.clickable-row {
  cursor: pointer;
  transition: background 0.15s;
}

.clickable-row:hover {
  background: #e8f4fd !important;
}

.expanded-emp-row {
  background: #e8f4fd !important;
}

.expand-arrow {
  margin-right: 8px;
  color: #888;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}

.expand-arrow svg {
  width: 13px;
  height: 13px;
}

.employee-report-row td {
  padding: 0 !important;
  background: #fafbfc;
}

.employee-report {
  padding: 16px 24px 20px;
}

.report-loading {
  text-align: center;
  padding: 24px;
  color: #888;
}

.report-empty {
  text-align: center;
  padding: 20px;
  color: #999;
  font-style: italic;
}

.report-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.report-tab {
  padding: 6px 14px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.report-tab.active {
  background: #0066cc;
  color: #fff;
  border-color: #0066cc;
}

.report-tab:hover:not(.active) {
  background: #f0f0f0;
}

.report-tab svg {
  width: 13px;
  height: 13px;
}

.report-tab-spam.active {
  background: #7c3aed;
  border-color: #7c3aed;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.report-table th {
  background: #eef2f7;
  padding: 8px 12px;
  text-align: left;
  font-weight: 600;
  color: #555;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
}

.report-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #f0f0f0;
}

.report-table tbody tr:hover {
  background: #f8f9fa;
}

.status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.status-badge.status-not_started {
  background: #f0f0f0;
  color: #666;
}

.status-badge.status-in_progress {
  background: #e3f2fd;
  color: #0066cc;
}

.status-badge.status-completed {
  background: #e8f5e9;
  color: #28a745;
}

.status-badge.status-spam {
  background: #ede9fe;
  color: #6d28d9;
}

/* Consultation row styles */
.consultation-row {
  cursor: pointer;
  transition: background 0.15s;
}

.consultation-row:hover {
  background: #f0f7ff !important;
}

.consultation-row.expanded-consultation {
  background: #e3f2fd !important;
  border-left: 3px solid #0066cc;
}

.consultation-row .expand-arrow {
  display: inline-flex;
  align-items: center;
  margin-right: 6px;
  color: #888;
}

.consultation-row .expand-arrow svg {
  width: 12px;
  height: 12px;
}

.consultation-details-row td {
  padding: 0 !important;
  background: #f8fafe;
  border-bottom: 2px solid #dee2e6 !important;
}

.consultation-details {
  padding: 20px 24px;
}

.consultation-details h4 {
  margin: 0 0 16px 0;
  color: #0066cc;
  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 7px;
}

.consultation-details h4 svg {
  width: 17px;
  height: 17px;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.detail-section {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e0e7ef;
}

.detail-section h5 {
  margin: 0 0 12px 0;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  padding-bottom: 8px;
  border-bottom: 2px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.detail-section h5 svg {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
}

.detail-row {
  display: flex;
  margin-bottom: 8px;
  font-size: 13px;
}

.detail-row.full-width {
  flex-direction: column;
}

.detail-label {
  font-weight: 500;
  color: #666;
  min-width: 140px;
  flex-shrink: 0;
}

.detail-value {
  color: #333;
  word-break: break-word;
}

.bool-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

.bool-status svg {
  width: 15px;
  height: 15px;
}

.bool-status-yes { color: #28a745; }
.bool-status-no { color: #dc3545; }
.bool-status-pending { color: #6c757d; }

.detail-value.message-text,
.detail-value.notes-text {
  margin-top: 6px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  line-height: 1.5;
  white-space: pre-wrap;
  font-size: 12px;
  border-left: 3px solid #0066cc;
}

/* HTML content styling for messages and notes */
.detail-value.message-text table,
.detail-value.notes-text table {
  border-collapse: collapse;
  margin: 10px 0;
  width: 100%;
  background: white;
  font-size: 12px;
}

.detail-value.message-text table td,
.detail-value.message-text table th,
.detail-value.notes-text table td,
.detail-value.notes-text table th {
  padding: 8px;
  border: 1px solid #ddd;
  text-align: left;
}

.detail-value.message-text table th,
.detail-value.notes-text table th {
  background: #f0f0f0;
  font-weight: 600;
}

.detail-value.message-text table tr:nth-child(even),
.detail-value.notes-text table tr:nth-child(even) {
  background: #fafafa;
}

.detail-value.message-text p,
.detail-value.notes-text p {
  margin: 8px 0;
}

.detail-value.message-text ul,
.detail-value.message-text ol,
.detail-value.notes-text ul,
.detail-value.notes-text ol {
  margin: 8px 0;
  padding-left: 20px;
}

.detail-value.message-text strong,
.detail-value.notes-text strong {
  font-weight: 600;
  color: #333;
}

.detail-value.message-text a,
.detail-value.notes-text a {
  color: #0066cc;
  text-decoration: underline;
}

.detail-value.highlight-amount {
  color: #28a745;
  font-weight: 700;
  font-size: 14px;
}

@media (max-width: 768px) {
  .statistics-page {
    padding: 16px;
  }

  .stats-summary {
    grid-template-columns: repeat(2, 1fr);
  }

  .stat-card {
    padding: 14px;
  }

  .stat-value {
    font-size: 20px;
  }

  .stats-table {
    font-size: 12px;
  }

  .stats-table th,
  .stats-table td {
    padding: 8px;
  }

  .details-grid {
    grid-template-columns: 1fr;
  }

  .detail-row {
    flex-direction: column;
  }

  .detail-label {
    min-width: auto;
    margin-bottom: 4px;
    font-size: 12px;
  }

  .detail-value {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/MeetingStatistics.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sCAAsC;EACtC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mBAAmB,0BAA0B,EAAE;AAC/C,sBAAsB,0BAA0B,EAAE;AAClD,uBAAuB,0BAA0B,EAAE;AACnD,wBAAwB,0BAA0B,EAAE;AACpD,0BAA0B,0BAA0B,EAAE;AACtD,kBAAkB,0BAA0B,EAAE;AAC9C,oBAAoB,0BAA0B,EAAE;;AAEhD;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,8BAA8B,cAAc,EAAE;AAC9C,iCAAiC,cAAc,EAAE;AACjD,kCAAkC,cAAc,EAAE;AAClD,mCAAmC,cAAc,EAAE;AACnD,qCAAqC,cAAc,EAAE;AACrD,6BAA6B,cAAc,EAAE;AAC7C,+BAA+B,cAAc,EAAE;;AAE/C;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,kBAAkB,cAAc,EAAE;AAClC,eAAe,cAAc,EAAE;AAC/B,kBAAkB,cAAc,EAAE;;AAElC;;;EAGE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oDAAoD;EACpD,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mBAAmB,cAAc,EAAE;AACnC,kBAAkB,cAAc,EAAE;AAClC,uBAAuB,cAAc,EAAE;;AAEvC;;EAEE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,8BAA8B;AAChC;;AAEA,gDAAgD;AAChD;;EAEE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".statistics-page {\n  padding: 24px;\n}\n\n.page-header {\n  margin-bottom: 24px;\n}\n\n.page-header h2 {\n  font-size: 28px;\n  color: #333;\n  margin: 0 0 8px 0;\n}\n\n.page-header p {\n  color: #666;\n  margin: 0;\n}\n\n.loading-spinner {\n  text-align: center;\n  padding: 60px;\n  color: #666;\n  font-size: 16px;\n}\n\n.error-message {\n  background: #fee;\n  color: #c00;\n  padding: 12px 16px;\n  border-radius: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.error-message button {\n  background: #c00;\n  color: white;\n  border: none;\n  padding: 6px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.stats-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 16px;\n  margin-bottom: 32px;\n}\n\n.stat-card {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  border-left: 4px solid #ddd;\n  transition: transform 0.2s;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n}\n\n.stat-card.total { border-left-color: #6c63ff; }\n.stat-card.assigned { border-left-color: #0066cc; }\n.stat-card.completed { border-left-color: #17a2b8; }\n.stat-card.successful { border-left-color: #28a745; }\n.stat-card.unsuccessful { border-left-color: #dc3545; }\n.stat-card.spam { border-left-color: #7c3aed; }\n.stat-card.amount { border-left-color: #ffc107; }\n\n.stat-icon {\n  font-size: 28px;\n}\n\n.stat-icon svg {\n  width: 28px;\n  height: 28px;\n}\n\n.stat-card.total .stat-icon { color: #6c63ff; }\n.stat-card.assigned .stat-icon { color: #0066cc; }\n.stat-card.completed .stat-icon { color: #17a2b8; }\n.stat-card.successful .stat-icon { color: #28a745; }\n.stat-card.unsuccessful .stat-icon { color: #dc3545; }\n.stat-card.spam .stat-icon { color: #7c3aed; }\n.stat-card.amount .stat-icon { color: #b45309; }\n\n.stat-info {\n  flex: 1;\n}\n\n.stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: #333;\n}\n\n.stat-label {\n  font-size: 12px;\n  color: #888;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-top: 2px;\n}\n\n.stats-section {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n}\n\n.stats-section h3 {\n  margin: 0 0 4px 0;\n  font-size: 18px;\n  color: #333;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.stats-section h3 svg {\n  width: 19px;\n  height: 19px;\n}\n\n.section-subtitle {\n  color: #888;\n  font-size: 13px;\n  margin: 0 0 16px 0;\n}\n\n.source-section {\n  margin-bottom: 24px;\n}\n\n.source-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 14px;\n}\n\n.source-card {\n  background: #f8f9fa;\n  border-radius: 10px;\n  padding: 14px 16px;\n  border: 1px solid #eee;\n  transition: transform 0.15s, box-shadow 0.15s;\n}\n\n.source-card:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n}\n\n.source-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.source-name {\n  font-weight: 600;\n  font-size: 14px;\n  color: #333;\n  text-transform: capitalize;\n}\n\n.source-count {\n  font-weight: 700;\n  font-size: 18px;\n  color: #0066cc;\n}\n\n.source-bar-bg {\n  height: 6px;\n  background: #e9ecef;\n  border-radius: 3px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.source-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #0066cc, #00a8ff);\n  border-radius: 3px;\n  transition: width 0.5s ease;\n  min-width: 2px;\n}\n\n.source-details {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 12px;\n}\n\n.source-pct {\n  font-weight: 600;\n  color: #555;\n}\n\n.source-breakdown {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.source-success,\n.source-fail,\n.source-pending {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.source-success { color: #28a745; }\n.source-fail { color: #dc3545; }\n.source-pending { color: #6c757d; }\n\n.source-success svg,\n.source-fail svg,\n.source-pending svg {\n  width: 12px;\n  height: 12px;\n}\n.source-spam {\n  color: #7c3aed;\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.source-spam svg {\n  width: 12px;\n  height: 12px;\n}\n\n.source-amount {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #28a745;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n}\n\n.source-amount svg {\n  width: 14px;\n  height: 14px;\n}\n\n.table-wrapper {\n  overflow-x: auto;\n}\n\n.stats-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.stats-table th {\n  background: #f8f9fa;\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: #555;\n  border-bottom: 2px solid #dee2e6;\n  white-space: nowrap;\n}\n\n.stats-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #eee;\n}\n\n.stats-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.center {\n  text-align: center;\n}\n\n.employee-name {\n  font-weight: 500;\n}\n\n.success-cell {\n  color: #28a745;\n  font-weight: 600;\n}\n\n.fail-cell {\n  color: #dc3545;\n  font-weight: 600;\n}\n\n.spam-cell {\n  color: #7c3aed;\n  font-weight: 600;\n}\n\n.amount-cell {\n  text-align: right;\n  font-weight: 500;\n  color: #333;\n  white-space: nowrap;\n}\n\n.rate-bar-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 120px;\n}\n\n.rate-bar {\n  height: 8px;\n  background: linear-gradient(90deg, #28a745, #20c997);\n  border-radius: 4px;\n  min-width: 2px;\n  transition: width 0.5s ease;\n  flex: 1;\n  max-width: 80px;\n}\n\n.rate-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #555;\n  min-width: 35px;\n}\n\n.totals-row {\n  background: #f0f7ff !important;\n}\n\n.totals-row td {\n  border-top: 2px solid #dee2e6;\n  border-bottom: none;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 40px;\n  color: #888;\n}\n\n.clickable-row {\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.clickable-row:hover {\n  background: #e8f4fd !important;\n}\n\n.expanded-emp-row {\n  background: #e8f4fd !important;\n}\n\n.expand-arrow {\n  margin-right: 8px;\n  color: #888;\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n}\n\n.expand-arrow svg {\n  width: 13px;\n  height: 13px;\n}\n\n.employee-report-row td {\n  padding: 0 !important;\n  background: #fafbfc;\n}\n\n.employee-report {\n  padding: 16px 24px 20px;\n}\n\n.report-loading {\n  text-align: center;\n  padding: 24px;\n  color: #888;\n}\n\n.report-empty {\n  text-align: center;\n  padding: 20px;\n  color: #999;\n  font-style: italic;\n}\n\n.report-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.report-tab {\n  padding: 6px 14px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: #fff;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.report-tab.active {\n  background: #0066cc;\n  color: #fff;\n  border-color: #0066cc;\n}\n\n.report-tab:hover:not(.active) {\n  background: #f0f0f0;\n}\n\n.report-tab svg {\n  width: 13px;\n  height: 13px;\n}\n\n.report-tab-spam.active {\n  background: #7c3aed;\n  border-color: #7c3aed;\n}\n\n.report-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n  background: #fff;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.report-table th {\n  background: #eef2f7;\n  padding: 8px 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #555;\n  border-bottom: 1px solid #ddd;\n  white-space: nowrap;\n}\n\n.report-table td {\n  padding: 8px 12px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.report-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.status-badge.status-not_started {\n  background: #f0f0f0;\n  color: #666;\n}\n\n.status-badge.status-in_progress {\n  background: #e3f2fd;\n  color: #0066cc;\n}\n\n.status-badge.status-completed {\n  background: #e8f5e9;\n  color: #28a745;\n}\n\n.status-badge.status-spam {\n  background: #ede9fe;\n  color: #6d28d9;\n}\n\n/* Consultation row styles */\n.consultation-row {\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.consultation-row:hover {\n  background: #f0f7ff !important;\n}\n\n.consultation-row.expanded-consultation {\n  background: #e3f2fd !important;\n  border-left: 3px solid #0066cc;\n}\n\n.consultation-row .expand-arrow {\n  display: inline-flex;\n  align-items: center;\n  margin-right: 6px;\n  color: #888;\n}\n\n.consultation-row .expand-arrow svg {\n  width: 12px;\n  height: 12px;\n}\n\n.consultation-details-row td {\n  padding: 0 !important;\n  background: #f8fafe;\n  border-bottom: 2px solid #dee2e6 !important;\n}\n\n.consultation-details {\n  padding: 20px 24px;\n}\n\n.consultation-details h4 {\n  margin: 0 0 16px 0;\n  color: #0066cc;\n  font-size: 15px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.consultation-details h4 svg {\n  width: 17px;\n  height: 17px;\n}\n\n.details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.detail-section {\n  background: #fff;\n  border-radius: 8px;\n  padding: 16px;\n  border: 1px solid #e0e7ef;\n}\n\n.detail-section h5 {\n  margin: 0 0 12px 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #555;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #f0f0f0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.detail-section h5 svg {\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n}\n\n.detail-row {\n  display: flex;\n  margin-bottom: 8px;\n  font-size: 13px;\n}\n\n.detail-row.full-width {\n  flex-direction: column;\n}\n\n.detail-label {\n  font-weight: 500;\n  color: #666;\n  min-width: 140px;\n  flex-shrink: 0;\n}\n\n.detail-value {\n  color: #333;\n  word-break: break-word;\n}\n\n.bool-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  white-space: nowrap;\n}\n\n.bool-status svg {\n  width: 15px;\n  height: 15px;\n}\n\n.bool-status-yes { color: #28a745; }\n.bool-status-no { color: #dc3545; }\n.bool-status-pending { color: #6c757d; }\n\n.detail-value.message-text,\n.detail-value.notes-text {\n  margin-top: 6px;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  font-size: 12px;\n  border-left: 3px solid #0066cc;\n}\n\n/* HTML content styling for messages and notes */\n.detail-value.message-text table,\n.detail-value.notes-text table {\n  border-collapse: collapse;\n  margin: 10px 0;\n  width: 100%;\n  background: white;\n  font-size: 12px;\n}\n\n.detail-value.message-text table td,\n.detail-value.message-text table th,\n.detail-value.notes-text table td,\n.detail-value.notes-text table th {\n  padding: 8px;\n  border: 1px solid #ddd;\n  text-align: left;\n}\n\n.detail-value.message-text table th,\n.detail-value.notes-text table th {\n  background: #f0f0f0;\n  font-weight: 600;\n}\n\n.detail-value.message-text table tr:nth-child(even),\n.detail-value.notes-text table tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.detail-value.message-text p,\n.detail-value.notes-text p {\n  margin: 8px 0;\n}\n\n.detail-value.message-text ul,\n.detail-value.message-text ol,\n.detail-value.notes-text ul,\n.detail-value.notes-text ol {\n  margin: 8px 0;\n  padding-left: 20px;\n}\n\n.detail-value.message-text strong,\n.detail-value.notes-text strong {\n  font-weight: 600;\n  color: #333;\n}\n\n.detail-value.message-text a,\n.detail-value.notes-text a {\n  color: #0066cc;\n  text-decoration: underline;\n}\n\n.detail-value.highlight-amount {\n  color: #28a745;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n@media (max-width: 768px) {\n  .statistics-page {\n    padding: 16px;\n  }\n\n  .stats-summary {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .stat-card {\n    padding: 14px;\n  }\n\n  .stat-value {\n    font-size: 20px;\n  }\n\n  .stats-table {\n    font-size: 12px;\n  }\n\n  .stats-table th,\n  .stats-table td {\n    padding: 8px;\n  }\n\n  .details-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .detail-row {\n    flex-direction: column;\n  }\n\n  .detail-label {\n    min-width: auto;\n    margin-bottom: 4px;\n    font-size: 12px;\n  }\n\n  .detail-value {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
